import { CSSProperties, useState } from "react";
import InputSymphony, { SelectOptionItem } from "elements/InputSymphony";
import { clsx, styx, timezoneParser } from "modules/Utils";

export interface ITimezoneOption {
    abbrev?: string;
    altName?: string;
    offset?: number;
    title: string;
    value: string;
}

type ICustomTimezone = {
    [key: string]: string;
};

type ILabelStyle = "original" | "altName" | "abbrev" | "abbrevNoPrefix";

interface TimezoneSelectProps {
    className?: string;
    style?: CSSProperties;
    timezone: ITimezoneOption | string;
    labelStyle?: ILabelStyle;
    onTimezoneSelect?: (timezone: ITimezoneOption) => void;
    timezones?: ICustomTimezone;
    maxWidth?: number;
}

const TimezoneSelect = ({
    className,
    style,
    timezone: timezoneProp,
    onTimezoneSelect: onTimezoneSelect,
    labelStyle = "original",
    maxWidth,
}: TimezoneSelectProps) => {
    const { timezoneOptions, parseTimezone } = timezoneParser(labelStyle);
    const [selectedTimezone, setSelectedTimezone] = useState<ITimezoneOption | null>(
        timezoneProp ? parseTimezone(timezoneProp) || null : null
    );

    const handleChange = (tz: ITimezoneOption) => {
        onTimezoneSelect && onTimezoneSelect(tz);
    };

    return (
        <InputSymphony
            className={clsx('timezoneSelect', className)}
            style={styx({ minWidth: 320, maxWidth }, style)}
            value={selectedTimezone?.value!}
            onOptionSelect={(option) => {
                setSelectedTimezone(option as ITimezoneOption)
                handleChange(option as ITimezoneOption)
            }}
            placeholder="Select Timezone"
            options={timezoneOptions as SelectOptionItem[]}
            isSelectDropdown
        />
    )
};

export default TimezoneSelect;
